module.exports = __webpack_public_path__ + "img/download.a6cd9ae0.svg";